import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AlertaService } from "../../services/alerta.service";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs";
import { BenefitGroupService } from "../../services/benefit-group.service";
import { findBenefitGroupAct, loadBenefitGroupByIdAct, saveBenefitGroupAct, saveSuccessBenefitGroupAct, 
    setViolationsBenefitGroupAct, showMsgErrorAct, updateBenefitGroupAct, updateSuccessBenefitGroupAct } from "./benefit-group.action";


@Injectable()
export class benefitGroupEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private benefitGroupService = inject(BenefitGroupService);
    private alerta = inject(AlertaService);

    findBenefitGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findBenefitGroupAct),
            exhaustMap(action => this.benefitGroupService.findBenefitGroupById(action.id)
                .pipe(
                    map(benefitGroup => loadBenefitGroupByIdAct({ benefitGroup })),
                    catchError(error => {
                        if(error.status == 500) {
                            this.alerta.error("Se ha precentado un error interno", {
                                detail: error.error.details ,
                                onAccept: () => {
                                  this.router.navigate(['/benefitsGroup']);
                                }}); // . stack -> mas detalle
                            return of();
                        }else {
                            //return of(showMsgErrorAct({ error }));
                            this.alerta.error("Se ha precentado un error interno: ", {detail: error.message});
                            return of();
                        }
                    })
                ))
        )
    );

    saveBenefitGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveBenefitGroupAct),
            exhaustMap(action => this.benefitGroupService.createBenefitGroup(action.benefitGroupNew)
                .pipe(
                    map(benefitGroupNew => saveSuccessBenefitGroupAct({ benefitGroupNew })),
                    catchError(error => (error.status == 400) ? of(setViolationsBenefitGroupAct({ benefitGroupForm: action.benefitGroupNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                    : of(showMsgErrorAct({ error }))
                    
                    )
                )
            )
        )
    );

    showMsgErrorEffect$ = createEffect(() =>
        this.actions$.pipe(
          ofType(showMsgErrorAct),
          tap(action => {
            const detail = action.error?.error?.message || action.error?.message || null;
            //console.log('showMsgErrorEffect 111:');
            this.alerta.error(
              'Se ha presentado un error interno Grupo Beneficios',
              detail ? { detail } : undefined
            );
            //console.log('showMsgErrorEffect 222:');
          })
        ),
        { dispatch: false }
      );

    saveSuccessBenefitGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessBenefitGroupAct),
        tap(() => {
            this.router.navigate(['/benefitsGroup']);
            this.alerta.correct("Grupo Beneficios creado con exito!");
        })
    ), { dispatch: false });

    updateBenefitGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateBenefitGroupAct),
            exhaustMap(action => this.benefitGroupService.updateBenefitGroup(action.benefitGroupUpdated)
                .pipe(
                    map(benefitGroupUpdated => updateSuccessBenefitGroupAct({ benefitGroupUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsBenefitGroupAct({ benefitGroupForm: action.benefitGroupUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessBenefitGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessBenefitGroupAct),
        tap(() => {
            this.router.navigate(['/benefitsGroup']);
            this.alerta.correct("rupo Beneficios editado con exito!");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
    
}